import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Ui/Dialog';
import { useIsMobile } from 'utils/hooks';
import PromotionDetails from '../PromotionDetails';

const LearnPromotion = ({ open, setStatus, displayRedeemDialog }) => {
  const isMobile = useIsMobile();
  return (
    <Dialog
      size="large"
      isAutoClose={false}
      isCloseIcon
      open={open}
      onClose={setStatus}
      fullScreen={isMobile}
    >
      <PromotionDetails
        validatePromotion={false}
        onClickAction={() => setStatus(false)}
        viewCart={false}
        showPromotionRedeem={displayRedeemDialog}
        onNext={() => {}}
        goNext={false}
      />
    </Dialog>
  );
};

LearnPromotion.propTypes = {
  open: PropTypes.bool.isRequired,
  setStatus: PropTypes.func.isRequired,
  displayRedeemDialog: PropTypes.func,
};

export default LearnPromotion;
